import React, {useContext, useEffect, useState} from 'react';
import * as Builder from "../../../builder";
import {ButtonBar} from "../../../builder";
import {MaxLengthConstraint, RequiredConstraint} from "../../../builder/form/validation/constraints";
import {Button} from "antd";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {observer} from "mobx-react";
import {StoreContext} from "../../../store.context";
import {useLoaderData, useNavigate} from "react-router-dom";
import {UserEditRequest} from "../../../types/modules/user/request";
import {TextType} from "../../../builder/form/type/TextType";
import {EmailType} from "../../../builder/form/type/EmailType";
import {PasswordType} from "../../../builder/form/type/PasswordType";
import {MyAccountViewResponse} from "../../../types/modules/user/response";

export const MyAccountEditForm: React.FC<{ onCancel?: () => void }> = observer(({onCancel}) => {
    const navigate = useNavigate();
    const data: MyAccountViewResponse = useLoaderData() as MyAccountViewResponse;
    const formReference = React.createRef() as any;

    const { appStore: { moduleStore: { userStore: { myAccountEdit }}} } = useContext(StoreContext);

    const [fetching, setFetching] = useState<boolean>(true);
    const [formErrors, setFormErrors] = useState<any>([])

    useEffect(() => {
        formReference.current?.setData(data);
        setFetching(false);
    }, [data])

    const onSubmit = (values: UserEditRequest) => {
        setFetching(true);
        myAccountEdit({...values})
                .then(() => {
                    navigate(`/my_account`);
                })
                .catch(error => {
                    setFormErrors(error.response.data.errors);
                })
                .finally(() => {
                    setFetching(false);
                })
    }

    return (
            <>
                    <Builder.Form
                            translationDomain={TranslationDomainEnum.USER_ADMINISTRATION}
                            formErrors={formErrors}
                            ref={formReference}
                            items={[
                                {
                                    title: <Translate message={`global.title.edit`} />,
                                    position: 'left',
                                    inputs: [
                                        {
                                            name: 'credentials.currentPassword',
                                            label: 'user.field.currentPassword',
                                            type: PasswordType,
                                            constraints: [
                                                RequiredConstraint(),
                                            ]
                                        },
                                        {
                                            name: 'credentials.otp',
                                            label: 'user.field.otp',
                                            type: TextType,
                                        },
                                        {
                                            name: 'firstName',
                                            label: 'user.field.firstName',
                                            type: TextType,
                                            constraints: [
                                                MaxLengthConstraint(150),
                                            ]
                                        },
                                        {
                                            name: 'lastName',
                                            label: 'user.field.lastName',
                                            type: TextType,
                                            constraints: [
                                                MaxLengthConstraint(150),
                                            ],
                                        },
                                        {
                                            name: 'initials',
                                            label: 'user.field.initials',
                                            type: TextType,
                                            constraints: [
                                                MaxLengthConstraint(20),
                                            ],
                                        },
                                        {
                                            name: 'additions',
                                            label: 'user.field.additions',
                                            type: TextType,
                                            constraints: [
                                                MaxLengthConstraint(50),
                                            ],
                                        },
                                        {
                                            name: 'email',
                                            label: 'user.field.email',
                                            type: EmailType,
                                            constraints: [
                                                MaxLengthConstraint(128),
                                                RequiredConstraint(),
                                            ],
                                        }
                                    ]
                                }
                            ]}
                            onFinish={(values: any) => {
                                onSubmit(values)
                            }}
                    />

                <ButtonBar>
                    <Button type="primary" loading={fetching} htmlType={`submit`} onClick={() => {
                        formReference.current?.submitForm()
                    }}><Translate message={`global.button.save`}/></Button>

                    <Button type="primary" className={`ant-btn-secondary`} onClick={() => navigate(`/my_account/password/edit`)}>
                        <Translate message={`user.button.change_password`}
                                   domain={TranslationDomainEnum.USER_ADMINISTRATION}/>
                    </Button>

                    <Button type="primary" className={`ant-btn-secondary`} onClick={() => {
                        onCancel && onCancel()
                    }}><Translate message={`global.button.view`}/></Button>
                </ButtonBar>
            </>
    )
})